import axios from 'axios';
// import store from '../store';,
function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/expensenote`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`expensenote/detail/${obj.trxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    accountbiaya() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/expensenote/coaexpense");
                                            
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get("/apinv/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("expensenote", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savedetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("expensenote/detail", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    updateTotal(obj) {
        const { data } = axios.put(`expensenote/${encodeURIComponent(obj.trxhdrkey)}`, obj);
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`expensenote/${obj.trxhdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    removedetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`expensenote/detail/${obj.trxkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['trxhdrkey'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/expensenote/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'catatan_pemakaian_dana.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },

};